import { render, staticRenderFns } from "./PermissionRecordListing.vue?vue&type=template&id=6a7df79a&scoped=true"
import script from "./PermissionRecordListing.vue?vue&type=script&lang=js"
export * from "./PermissionRecordListing.vue?vue&type=script&lang=js"
import style0 from "./PermissionRecordListing.vue?vue&type=style&index=0&id=6a7df79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7df79a",
  null
  
)

export default component.exports